import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import React from 'react';
import { RootState } from '../../../store';

interface ILanguage {
  lang: string;
}
const initialState: ILanguage = {
  lang: 'en',
};
export const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    languageSelect: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        lang: action.payload,
      };
    },
  },
});

export const { languageSelect } = languageSlice.actions;
export const selectLang = (state: RootState) => state.language;
export const languageReducer = languageSlice.reducer;
